var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clone } from "../../../../../Shared/utils/clone";
import { RecipeModuleText, } from "../utils/RecipeModule-Types";
import { incrementRecipe_V2 } from "./incrementRecipe_V2";
/**
 * Adds a recipe assignment to a meal on the selectedDay.
 * This function updates the CustomizationContext which controls the Customization modal.
 *
 * @param enableAssignRecipes
 * @param enableAddMeals
 * @param enableRemoveMeals
 * @param cartMeals
 * @param program
 * @param deliveryDays
 * @param selectedDay
 * @param assignmentId
 * @param setAssignmentId
 * @returns
 */
export const handleCustomizeIncrement_V2 = ({ enableAssignRecipes, enableAddMeals, enableRemoveMeals, customizationMeals, program, deliveryDays, selectedDay, assignmentId, setAssignmentId, recipe, programMealId, setMeals, setIsAddDisabled, setQuantity, shouldSetAssignmentId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedMeals = clone(customizationMeals);
    const { meals, disableAddButton, currentAssignmentQuantity } = yield incrementRecipe_V2({
        enableAssignRecipes,
        enableAddMeals,
        enableRemoveMeals,
        clonedMeals,
        program,
        deliveryDays,
        selectedDay,
        recipe,
        programMealId,
        assignmentId,
        createNewAssignment: false,
        shouldSetAssignmentId,
        setAssignmentId,
    });
    if (currentAssignmentQuantity === undefined) {
        throw new Error(RecipeModuleText.UpdateError);
    }
    setMeals(meals);
    setIsAddDisabled(!!disableAddButton);
    setQuantity(currentAssignmentQuantity);
});
